export enum ErrorType {
  UNKNOWN = 'unknown',
  BEHOERDENCLIENT_PROBLEMS_USER_LOGGED_IN = 'behoerdenclient/problems/userLoggedIn',
  BEHOERDENCLIENT_PROBLEMS_UPDATE_NOT_ALLOWED = 'behoerdenclient/problems/updateNotAllowed',
  BEHOERDENCLIENT_PROBLEMS_USER_CONFLICT = 'behoerdenclient/problems/userConflict',
  BEHOERDENCLIENT_PROBLEMS_USER_CANNOT_BE_DELETED = 'behoerdenclient/problems/userCannotBeDeleted',
  BEHOERDENCLIENT_PROBLEMS_CASES_LINKED = 'behoerdenclient/problems/casesLinked',
  BEHOERDENCLIENT_PROBLEMS_MULTIPLE_MANDANTS_LINKED = 'behoerdenclient/problems/multipleMandantsLinked',
  BEHOERDENCLIENT_PROBLEMS_CASES_MULTIPLE_USED_DESTINATIONS_LINKED = 'behoerdenclient/problems/multipleUsedDestination',
  BEHOERDENCLIENT_PROBLEMS_ZBP_KEYPAIR_NOT_FOUND = 'behoerdenclient/problems/zbpKeypairNotFound',
  BEHOERDENCLIENT_PROBLEMS_INVALID_DATA_MODEL = 'behoerdenclient/problems/invalidDataModel',
  BEHOERDENCLIENT_PROBLEMS_ILLEGAL_CREDENTIAL_NOT_A_SUBSCRIBER = 'behoerdenclient/problems/clientInvalid/notASubscriberCredential',
  BEHOERDENCLIENT_PROBLEMS_ILLEGAL_CREDENTIAL_NOT_A_SENDER = 'behoerdenclient/problems/clientInvalid/notASenderCredential',
  BEHOERDENCLIENT_PROBLEMS_FITCONNECT_DESTINATION_NOT_FOUND = 'behoerdenclient/problems/destinationKeyNotFound',
  BEHOERDENCLIENT_PROBLEMS_ENCRYPTION_KEY_NOT_FOUND = 'behoerdenclient/problems/encryptionKeyNotFound',
  BEHOERDENCLIENT_PROBLEMS_SIGNING_KEY_NOT_FOUND = 'behoerdenclient/problems/signingKeyNotFound',
  BEHOERDENCLIENT_PROBLEMS_JWK_ENCRYPTION_KEYPAIR_VALIDATION_ERROR = 'behoerdenclient/problems/JwkEncryptionKeyPairValidationError',
  BEHOERDENCLIENT_PROBLEMS_JWK_SIGNING_KEYPAIR_VALIDATION_ERROR = 'behoerdenclient/problems/JwkSigningKeyPairValidationError',
  BEHOERDENCLIENT_PROBLEMS_INVALID_REQUEST = 'behoerdenclient/problems/invalidRequest',
  BEHOERDENCLIENT_PROBLEMS_PENDING_VERSAND = 'behoerdenclient/problems/pendingVersand'
}

export enum ReasonType {
  BEHOERDENCLIENT_REASONS_USER_HAS_CASES = 'userHasCases',
  BEHOERDENCLIENT_REASONS_USER_IS_ONLY_ADMIN = 'userIsOnlyAdmin',
  BEHOERDENCLIENT_REASONS_UNSUPPORTED_SCHEMA_URIS = 'unsupportedSchemaUris',
  BEHOERDENCLIENT_REASONS_NOT_FOUND_DESTINATION_ID = 'notFoundDestinationId',
  BEHOERDENCLIENT_REASONS_NOT_FOUND_SOURCE_DESTINATION_ID = 'notFoundSourceDestinationId',
  BEHOERDENCLIENT_REASONS_INACTIVE_DESTINATION_ID = 'inactiveDestinationId',
  BEHOERDENCLIENT_REASONS_NOT_FOUND_PUBLIC_SERVICE_IDENTIFIER = 'notFoundPublicServiceIdentifier'
}

export interface ReasonsType {
  type: ReasonType;
  schemaUris?: string[];
  destinationId?: string;
  publicServiceIdentifier?: string;
}

export enum ERROR_CASE_CLIENT {
  NOT_AUTHORIZED
}

const errorMsgBackend =
  'Bitte wenden Sie sich mit folgendem Error-Code an Ihren Administrator.';

const errorMsgClient = 'Bitte wenden Sie sich an Ihren Administrator';

export const fjdAlertErrorBackendMsg = 'Es ist ein Fehler aufgetreten. '.concat(
  errorMsgBackend
);

export const useAlertErrorMsg = 'Fehler. '.concat(errorMsgBackend);

export const conflictErrorMsgWithReloadHint =
  'Das Objekt wurde seit dem Laden verändert. Bitte laden Sie die Seite neu und führen Sie die Aktion erneut durch.';

export const conflictErrorMsg =
  'Das Objekt wurde seit dem Laden verändert. Bitte führen Sie die Aktion erneut durch.';

export const userConflictErrorMsg = 'Diese Mailadresse wird bereits verwendet.';

export const conflictCasesLinked =
  'Zustellpunkte konnten nicht aktualiert werden, da noch Anträge im Mandanten vorhanden sind.';

export const conflictMultipleMandantsLinked =
  'Ein oder mehrere der ausgewählten Zustellpunkte ist bereits mit einem anderen Mandanten verknüpft. Eine erneute Zuweisung ist nicht möglich.';

export const conflictMultipleUsedDestination =
  'Ein oder mehrere der ausgewählten Zustellpunkte soll mehrfach zugewiesen werden.';

export const fitconnectDestinationNotFound =
  'Der Zustellpunkt wurde in Fit-Connect nicht gefunden. Bitte überprüfen Sie die Zustellpunkt-ID.';

export const fitconnectEncryptionKeyNotFound =
  'Der Verschlüsselungsschlüssel wurde in Fit-Connect nicht gefunden. Bitte überprüfen Sie den hochgeladenen Schlüssel.';

export const fitconnectSigningKeyNotFound =
  'Der Signaturschlüssel wurde in Fit-Connect nicht gefunden. Bitte überprüfen Sie den hochgeladenen Schlüssel.';

export const fitconnectEncryptionKeypairInvalid =
  'Das hochgeladene Schlüsselpaar zur Verschlüsselung ist ungültig. Bitte überprüfen Sie die Schlüssel.';

export const fitconnectSigningKeypairInvalid =
  'Das hochgeladene Signaturschlüsselpaar ist ungültig. Bitte überprüfen Sie die Schlüssel.';

export const conflictZbpKeypairNotFound =
  'Die BundID ist aktuell nicht als Rückkanal konfiguriert. Eine Zustellung der Nachricht ist daher nicht möglich.';

export const conflictPendingVersand =
  'Der Antrag kann nicht abgeschlossen werden, da noch ein Versandauftrag ausstehend ist.';

export const fjdAlertErrorClientMsg = `Es ist ein Fehler aufgetreten. ${errorMsgClient}`;

const error_NotAuthorized = `${fjdAlertErrorClientMsg} (Kein Zugriff).`;

export function getErrorMsgClient(errorCase: ERROR_CASE_CLIENT): string {
  switch (errorCase) {
    case ERROR_CASE_CLIENT.NOT_AUTHORIZED:
      return error_NotAuthorized;
    default:
      return `${fjdAlertErrorClientMsg}.`;
  }
}
